
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#27AE60","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.372 23.513a1.276 1.276 0 01-1.243-1.56l1.544-6.801L.437 10.56a1.275 1.275 0 01.723-2.232l6.928-.63 2.739-6.41a1.275 1.275 0 012.346 0l2.74 6.41 6.926.63c.51.046.94.391 1.098.877a1.275 1.275 0 01-.373 1.355l-5.236 4.591 1.544 6.801a1.275 1.275 0 01-1.898 1.378L12 19.76l-5.974 3.572c-.202.12-.427.181-.654.181zM12 18.223c.227 0 .452.06.654.18l5.638 3.372-1.457-6.419a1.275 1.275 0 01.404-1.243l4.944-4.336-6.541-.594a1.274 1.274 0 01-1.06-.773L12 2.36 9.415 8.41a1.27 1.27 0 01-1.057.771l-6.542.594 4.944 4.336c.354.31.509.786.404 1.244l-1.456 6.42 5.638-3.372c.202-.12.427-.18.654-.18zm-3.965-10.4l-.001.002v-.002zm7.928-.003l.001.002-.001-.002z"}})])
          )
        }
      }
    